//// Application Packages
import React from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { format } from 'date-fns'

//// Application Slices
import { selectSettings } from '../../reducers/settingSlice'
import {
    updateFormData,
    updateFormValidity,
    selectForms,
} from '../../reducers/formSlice'

//// Application Components

//// Carbon Components
import {
    RadioButton,
    RadioButtonGroup,
    DatePicker,
    DatePickerInput,
} from '@carbon/react'

//// Carbon Icons

//// Static Constants

//////// Component
const AdditionalMilitaryWaiverDateForm = () => {
    //////// Hooks
    const dispatch = useDispatch()

    //////// State

    //////// Slices
    const settingsData = useSelector(selectSettings)
    const formsData = useSelector(selectForms)

    //// Slice Data
    const digital_name = settingsData?.['form']?.['digital_name']

    //////// Search Params

    //////// Methods

    // Re-Validate Data Submission
    const revalidation = async (event_name) => {
        // Update Validation State
        if (digital_name && event_name) {
            dispatch(
                updateFormValidity({
                    digital_name: digital_name,
                    errors: {
                        [event_name]: false,
                        [event_name + 'ErrMsg']: '',
                    },
                })
            )
        }
    }

    //////// Functional Methods

    // Handle Data Of All Fields + DatePicker (ID)
    const handleData = (e, id) => {
        if (e?.target?.name && e?.target?.value) {
            dispatch(
                updateFormData({
                    digital_name: digital_name,
                    values: {
                        [e.target.name]: e.target.value,
                    },
                })
            )
            revalidation(e.target.name)
        } else if (e?.target?.name) {
            dispatch(
                updateFormData({
                    digital_name: digital_name,
                    values: { [e.target.name]: '' },
                })
            )
            revalidation(e.target.name)
        } else if (e?.length > 0 && id) {
            dispatch(
                updateFormData({
                    digital_name: digital_name,
                    values: {
                        [id]: format(new Date(e?.[0]), 'MM/dd/yyyy'),
                    },
                })
            )
            revalidation(id)
        }
        //// Start Watson Assistant Journey

        //// End Watson Assistant Journey
    }

    //////// Memoization

    //////// Effects/Side Effects

    //////////////// Render & Return
    if (formsData?.[digital_name]?.values?.HON_DISCHG === 'Y') {
        return (
            <>
                <RadioButtonGroup
                    className={
                        formsData?.[digital_name]?.errors?.ACTV
                            ? 'required invalid'
                            : 'required'
                    }
                    defaultSelected={formsData?.[digital_name]?.values?.ACTV}
                    valueSelected={formsData?.[digital_name]?.values?.ACTV}
                    legendText="Is the qualifying veteran the applicant or the spouse of the applicant?"
                    name="ACTV"
                    invalid={formsData?.[digital_name]?.errors?.ACTV}
                    invalidText={formsData?.[digital_name]?.errors?.ACTVErrMsg}
                >
                    <RadioButton
                        id="ACTVApplicant"
                        name="ACTVApplicant"
                        labelText="Applicant"
                        value="A"
                        type="radio"
                        onClick={handleData}
                    />
                    <RadioButton
                        id="ACTVSpouse"
                        name="ACTVSpouse"
                        labelText="Spouse"
                        value="S"
                        type="radio"
                        onClick={handleData}
                    />
                </RadioButtonGroup>

                <DatePicker
                    dateFormat="m/d/Y"
                    datePickerType="single"
                    onChange={(e) => handleData(e, 'DUTY_END')}
                    onClose={(e) => handleData(e, 'DUTY_END')}
                    value={formsData?.[digital_name]?.values?.DUTY_END}
                >
                    <DatePickerInput
                        className="required"
                        labelText="Date of Honorable Discharge:"
                        id="DUTY_END"
                        name="DUTY_END"
                        placeholder="MM/DD/YYYY"
                        type="text"
                        invalid={formsData?.[digital_name]?.errors?.DUTY_END}
                        invalidText={
                            formsData?.[digital_name]?.errors?.DUTY_ENDErrMsg
                        }
                    />
                </DatePicker>
            </>
        )
    }
}

export default AdditionalMilitaryWaiverDateForm
